import axios from 'axios';

export default {
  fetchPrivacyAuditList({
    commit,
  }, paginationParams) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get('/privacyAudit', {
      params: paginationParams,
    })
      .then((privacyAudits) => {
        commit('setData', privacyAudits);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  downloadReport(_, id) {
    console.log(`params: ${id}`);

    return axios.get(`/privacyAudit/report/pdf/${id}`, {
      responseType: 'blob',
      timeout: 30000,
    });
  },
  downloadReportWord(_, id) {
    return axios.get(`/privacyAudit/report/word/${id}`, {
      responseType: 'blob',
      timeout: 30000,
    });
  },
};
